export default "__VITE_ASSET__CUqeNmO4__"